import React, { useCallback, useState } from 'react';

import { Dialog, IconButton, SvgIcon } from '@mui/material';

import SearchBar from 'pages/layout/components/SearchBar';

import IconClose from './assets/close.svg';
import IconSearch from './assets/search.svg';
import useStyles from './styles';

interface Props {
    container?: () => HTMLElement;
    className?: string;
}

const DrawerMenuButton: React.FC<Props> = ({ className, container }) => {
    const { classes, cx } = useStyles();

    const [isOpen, setIsOpen] = useState(false);

    const toggle = useCallback(() => setIsOpen((state) => !state), []);
    const close = useCallback(() => setIsOpen(false), []);

    return (
        <>
            <IconButton onClick={toggle} disableFocusRipple centerRipple className={cx(classes.button, className)}>
                <SvgIcon>
                    <IconSearch />
                </SvgIcon>
            </IconButton>
            <Dialog
                open={isOpen}
                fullScreen
                hideBackdrop
                onClose={close}
                container={container}
                classes={{ paper: classes.paper }}
            >
                <SearchBar
                    variant="mobile"
                    className={classes.searchBar}
                    inputClassName={classes.searchBarInput}
                    listClassName={classes.searchBarList}
                    onSubmit={close}
                />
                <IconButton
                    onClick={close}
                    disableFocusRipple
                    centerRipple
                    className={cx(classes.button, classes.close)}
                >
                    <SvgIcon>
                        <IconClose />
                    </SvgIcon>
                </IconButton>
            </Dialog>
        </>
    );
};

export default DrawerMenuButton;
